
import { isNullOrUndefined, findRule } from '../Utils'

const validate = vObj => {
  let value = vObj.value
  let rule = findRule(vObj.errorBag, 'min')
  let length = rule.ruleParams

  rule.feedback = `${vObj.fieldlabel} requires a minimum of ${length} characters`

  if (isNullOrUndefined(value)) {
    return false
  }

  return String(value).length >= length
}

export {
  validate
}

export default {
  validate
}
